import { Box } from '@mui/material';

const RingCentralMobile = () => {
  return <Box></Box>;
};

export default RingCentralMobile;
